// EMPLOYEE MODALS

const LINKEDIN_IMPORT = 'LINKEDIN_IMPORT';
const SOCIAL = 'SOCIAL';
const ABOUT_YOU = 'ABOUT_YOU';
const PROJECTS = 'PROJECTS';
const INTERESTS = 'INTERESTS';
const HOBBIES = 'HOBBIES';
const SAVE = 'SAVE';
const VOLUNTEER = 'VOLUNTEER';
const AWARDS = 'AWARDS';
const LANGUAGE = 'LANGUAGE';
const EDUCATION = 'EDUCATION';
const EXPERIENCE = 'EXPERIENCE';
const MOD_EXPERIENCE_ACTUAL = 'MOD_EXPERIENCE_ACTUAL';
const MOD_EXPERIENCE_PAST = 'MOD_EXPERIENCE_PAST';
const DELETE_EXPERIENCE_PAST = 'DELETE_EXPERIENCE_PAST';

export {
  LINKEDIN_IMPORT,
  SOCIAL,
  ABOUT_YOU,
  PROJECTS,
  INTERESTS,
  SAVE,
  HOBBIES,
  VOLUNTEER,
  AWARDS,
  LANGUAGE,
  EDUCATION,
  EXPERIENCE,
  MOD_EXPERIENCE_ACTUAL,
  MOD_EXPERIENCE_PAST,
  DELETE_EXPERIENCE_PAST
};
